/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import { apiUrl, headerconfig } from "../Settings/Config";
import {
  showLoader,
  userID,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  showContaimerLoader,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import isEmail from "validator/lib/isEmail";
var module = "vendors/";
var moduleName = "Vendor";

class Form extends Component {
  constructor(props) {
    super(props);
    var editID = this.props.location.state?.editID;
    this.state = {
      editID:
        editID !== "" &&
        typeof editID !== undefined &&
        typeof editID !== "undefined"
          ? editID
          : "",
      userID: userID(),
      postdata: {
        vendorName: "",
        vendorAddress: "",
        vendorGSTNo: "",
        vendorGSTCode: "",
        vendorContactPerson: "",
        vendorEmail: "",
        vendorPhone: "",
        status: "",
      },
      brandList: [],
      detaildata: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    this.loadBrand();
    if (this.state.editID !== "") {
      var params = {
        params:
          "&userID=" + this.state.userID + "&detail_id=" + this.state.editID,
        url: module + "details",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push("/" + module);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      this.state.editID !== ""
    ) {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var vendorStatus =
            result.vendorStatus === "A" ? "Active" : "In Active";
          var status =
            result.vendorStatus !== "" && result.vendorStatus !== null
              ? {
                  label: vendorStatus,
                  value: result.vendorStatus,
                }
              : "";
          var clientupdatedata = {
            vendorName: result.vendorName,
            vendorAddress: result.vendorAddress,
            vendorGSTNo: result.vendorGSTNo,
            vendorGSTCode: result.vendorGSTCode,
            vendorContactPerson: result.vendorContactPerson,
            vendorEmail: result.vendorEmail,
            vendorPhone: result.vendorPhone,
            status: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push("/" + module);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadBrand() {
    var urlShringTxt =
      apiUrl + "brand/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ brandList: res.data.result });
      }
    });
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      vendorName: postData.vendorName,
      vendorAddress: postData.vendorAddress,
      vendorGSTNo: postData.vendorGSTNo,
      vendorGSTCode: postData.vendorGSTCode,
      vendorContactPerson: postData.vendorContactPerson,
      vendorEmail: postData.vendorEmail,
      vendorPhone: postData.vendorPhone,
      status:
        Object.keys(postData.status).length > 0 ? postData.status?.value : "A",
      userID: this.state.userID,
    };

    var post_url = module + "add";
    if (this.state.editID !== "") {
      postObject["edit_id"] = this.state.editID;
      post_url = module + "update";
    }
    this.props.getFormPost(postObject, post_url, "add");
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="vendor" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={"/vendors"}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            brandList={this.state.brandList}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const {
    vendorName,
    vendorAddress,
    vendorGSTNo,
    vendorGSTCode,
    vendorEmail,
    status,
  } = props.fields;

  return {
    fields: [
      "vendorName",
      "vendorAddress",
      "vendorGSTNo",
      "vendorGSTCode",
      "vendorEmail",
      "status",
    ],
    validations: {
      vendorName: [[isEmpty, vendorName]],
      vendorEmail: [[isEmail, vendorEmail]],
      vendorAddress: [[isEmpty, vendorAddress]],
      vendorGSTNo: [[isEmpty, vendorGSTNo]],
      vendorGSTCode: [[isEmpty, vendorGSTCode]],
      status: [[isSingleSelect, status]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
  }

  goBack() {
    this.props.history.push("/vendors");
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgvendorName,
      errMsgvendorAddress,
      errMsgvendorGSTNo,
      errMsgvendorGSTCode,
      errMsgvendorEmail,
      errMsgStatus = "";

    if ($validation.vendorName.error.reason !== undefined) {
      errMsgvendorName = $validation.vendorName.show && (
        <span className="error">{$validation.vendorName.error.reason}</span>
      );
    }
    if ($validation.vendorAddress.error.reason !== undefined) {
      errMsgvendorAddress = $validation.vendorAddress.show && (
        <span className="error">{$validation.vendorAddress.error.reason}</span>
      );
    }
    if ($validation.vendorGSTNo.error.reason !== undefined) {
      errMsgvendorGSTNo = $validation.vendorGSTNo.show && (
        <span className="error">{$validation.vendorGSTNo.error.reason}</span>
      );
    }
    if ($validation.vendorGSTCode.error.reason !== undefined) {
      errMsgvendorGSTCode = $validation.vendorGSTCode.show && (
        <span className="error">{$validation.vendorGSTCode.error.reason}</span>
      );
    }
    if ($validation.vendorEmail.error.reason !== undefined) {
      errMsgvendorEmail = $validation.vendorEmail.show && (
        <span className="error">{$validation.vendorEmail.error.reason}</span>
      );
    }

    if ($validation.status.error.reason !== undefined) {
      errMsgStatus = $validation.status.show && (
        <span className="error">{$validation.status.error.reason}</span>
      );
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Vendor Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Vendor Name"
                name="vendorName"
                value={fields.vendorName}
                {...$field("vendorName", (e) =>
                  onChange("vendorName", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgvendorName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Address<span className="lbl-error">*</span>
              </label>

              <input
                type="text"
                className="form-control"
                placeholder="Address1"
                name="vendorAddress"
                value={fields.vendorAddress}
                {...$field("vendorAddress", (e) =>
                  onChange("vendorAddress", e.target.value)
                )}
              />
              {errMsgvendorAddress}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                GSTNo.<span className="lbl-error">*</span>
              </label>

              <input
                type="text"
                className="form-control"
                placeholder="GST No."
                name="vendorGSTNo"
                value={fields.vendorGSTNo}
                {...$field("vendorGSTNo", (e) =>
                  onChange("vendorGSTNo", e.target.value)
                )}
              />
              {errMsgvendorGSTNo}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                GST Code.<span className="lbl-error">*</span>
              </label>

              <input
                type="text"
                className="form-control"
                placeholder="GST Code"
                name="vendorGSTCode"
                value={fields.vendorGSTCode}
                {...$field("vendorGSTCode", (e) =>
                  onChange("vendorGSTCode", e.target.value)
                )}
              />
              {errMsgvendorGSTCode}
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">Contact Person</label>
              <input
                type="text"
                className="form-control"
                placeholder="Contact Person"
                name="vendorContactPerson"
                value={fields.vendorContactPerson}
                {...$field("vendorContactPerson", (e) =>
                  onChange("vendorContactPerson", e.target.value)
                )}
                maxLength={255}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Mobile</label>
              <input
                type="text"
                className="form-control"
                placeholder="Mobile"
                name="vendorPhone"
                value={fields.vendorPhone}
                {...$field("vendorPhone", (e) =>
                  onChange("vendorPhone", e.target.value)
                )}
                maxLength={255}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Email</label>
              <input
                type="text"
                className="form-control"
                placeholder="Email"
                name="vendorEmail"
                value={fields.vendorEmail}
                {...$field("vendorEmail", (e) =>
                  onChange("vendorEmail", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgvendorEmail}
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.status}
                onChange={this.handleSelectChange.bind(this, "status")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Submit
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.goBack.bind(this)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
